/**
 * Route path constants for the application
 * Centralized route definitions to ensure consistency across the app
 */

export const RoutePaths = {
  HOME: '/',
  APPLIANCES: '/appliances',
  APPLIANCE_DETAILS: '/appliances/:applianceId',
  REQUESTS: '/requests',
  REQUEST_VIEW: '/requests/:requestId',
  HOLDOVER_KDMS: '/request-holdover-kdms/:movieId',
  USERS: '/users',
  USERS_LOGS: '/users/logs',
  ADMIN_USERS: '/admin/:companyID/users',
  ADMIN_GROUPS: '/admin/:companyID/groups',
  GROUPS: '/groups',
  GROUP_LOGS: '/group/logs',
  GROUP_DETAIL: '/groups/:groupId',
  EDIT_GROUP: '/edit-group/:groupId',
  GROUP_ADMIN: '/admin/:companyID/groups/:groupId',
  CREATE_GROUP: '/create-group',
  FACILITY_DEVICES: '/facilities/:facilityId',
  FACILITY_SUITE_LOGS: '/facilities/:facilityId/suite-logs',
  REPORTS: '/reports',
  WIRELINKS: '/wirelinks',
  ERROR: '*',
};

export default RoutePaths;
